/**
 * The display name to fall back to when the user has not chosen one: their
 * account name, otherwise the local part of their email, otherwise an empty
 * string. Pure — the same inputs always produce the same result.
 */
export function resolveDefaultDisplayName(name: string, email: string): string {
  return name || email.split('@')[0] || '';
}
